import React from 'react';

const GlossaryItem = ({ item, selectedWord, setSelectedWord }) => (
  <li
    className={`glossary-item ${selectedWord === item ? 'selected' : ''}`}
    onClick={() => setSelectedWord(item)}
  >
    {item}
  </li>
);

export default GlossaryItem;
